// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var BrowserStyle = require("../../../../shared-browser/src/BrowserStyle.bs.js");
var BrowserComponents_Text = require("../../../../shared-browser/src/components/BrowserComponents_Text.bs.js");
var BrowserComponents_Spacer = require("../../../../shared-browser/src/components/BrowserComponents_Spacer.bs.js");
var WebComponents_JobcasePixel = require("../../components/WebComponents_JobcasePixel.bs.js");
var BrowserComponents_GetAppButtons = require("../../../../shared-browser/src/components/BrowserComponents_GetAppButtons.bs.js");

function arg(param) {
  return BrowserStyle.withFont(param, /* Quicksand */0, /* XLarge */5, /* Bold */2);
}

var title = Curry._1(BrowserStyle.style, Curry._1(arg(undefined), /* [] */0));

var buttons = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignSelf(BrowserStyle.center),
      tl: /* [] */0
    });

var Styles = {
  title: title,
  buttons: buttons
};

function WebContainers_Signup_Professional_Success$TalentPixel(Props) {
  return React.createElement("img", {
              src: "https://www.talent.com/tracker/img-pixel.php?tracker=qwick-corp"
            });
}

var TalentPixel = {
  make: WebContainers_Signup_Professional_Success$TalentPixel
};

function WebContainers_Signup_Professional_Success(Props) {
  return React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Text.make, {
                  className: title,
                  children: "Next Steps"
                }), React.createElement(BrowserComponents_Spacer.make, {
                  size: /* Medium */4
                }), React.createElement(BrowserComponents_Text.make, {
                  children: "Download the Qwick Professionals app for your device and login to setup your profile, attend a one-time orientation, and start getting matched with shifts!"
                }), React.createElement(BrowserComponents_Spacer.make, {
                  size: /* XLarge */6
                }), React.createElement(BrowserComponents_GetAppButtons.Professional.make, {
                  className: buttons
                }), React.createElement(WebComponents_JobcasePixel.make, {}), React.createElement(WebContainers_Signup_Professional_Success$TalentPixel, {}));
}

var make = WebContainers_Signup_Professional_Success;

exports.Styles = Styles;
exports.TalentPixel = TalentPixel;
exports.make = make;
/* title Not a pure module */
